<div class="container-xl">
    <div class="d-flex justify-content-between">

        <app-breadcrumb [crumbs]="crumbs"></app-breadcrumb>
        <button
            (click)="queueImmediately()"
            [class.queue-failed]="failedPush()"
            [class.queue-success]="successfulPush()"
            mat-icon-button
            matTooltip="Zet de checkpoint met hoge prioriteit in de wachtrij">
            <mat-icon fontIcon="fa-play" fontSet="fas"></mat-icon>
        </button>
    </div>
    <app-checkpoint-header [checkpoint]="checkpoint()" [platform]="platform()"></app-checkpoint-header>
    <div class="row">
        <div class="col-auto">
            <table class="table table-hover table-last-col table-add-row">
                <thead>
                    <tr>
                        <th>Datum</th>
                        <th>Uitgevoerd</th>
                        <th class="text-end">Duur</th>
                        <th class="text-end">Grootte</th>
                        <th class="w-0">Status</th>
                        <th class="w-0">Statuscode</th>
                        <th>Probleem</th>
                    </tr>
                </thead>
                <tbody>
                    @for (checkpointResult of checkpointResults(); track checkpointResult.id) {
                        <tr class="curpoint" routerLink="/{{Routenames.seire}}/{{this.platformId}}/overview/{{checkpoint().id}}/{{checkpointResult.id}}">
                            <td>{{checkpointResult.finish_date ?? checkpointResult.start_date | date: 'EEE d MMM yyyy HH:mm'}}</td>
                            <td>{{(checkpointResult.finish_date | msBetween: checkpointResult.start_date) ?? '-'}}</td>
                            <td class="text-end">
                                @if (checkpointResult.duration) {
                                    {{checkpointResult.duration | duration}}
                                } @else {
                                    -
                                }
                            </td>
                            <td class="text-end">{{checkpointResult.size | bytesPipe}}</td>
                            <td class="pb-0 pt-1">
                                <div class="d-flex justify-content-center">
                                    <div [class]="checkpointResult | CheckpointResultLevelStatusPipe"></div>
                                </div>
                            </td>
                            <td>{{checkpointResult.response_status_code}}</td>
                            <td>
                                <div class="overflow-hidden ellipsis" style="max-width: 150px;">{{checkpointResult.result}}</div>
                            </td>
                        </tr>
                    } @empty {
                        <tr>
                            <td class="text-center" colspan="99">
                                @if (checkpoint() === null) {
                                    Aan het laden...
                                } @else {
                                    Geen checkpoint resultaten gevonden
                                }
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
        @if (checkpointComments()) {
            <div class="col">
                <div class="row gap-2">
                    @if (formCreateComment()) {
                        <div class="comment-container py-2">
                            <div [formGroup]="formCreateComment()" class="row gap-2">
                                <div class="col-12">
                                    <b>Opmerking en/of opschorten</b>
                                    <div class="row">
                                        <mat-form-field>
                                            <textarea formControlName="comment" matInput name="comment" placeholder="Opmerking" rows="5"></textarea>
                                        </mat-form-field>
                                    </div>

                                </div>
                                <div class="col-12">
                                    <div class="row">
                                        <mat-form-field>
                                            <input
                                                formControlName="postpone_hours"
                                                matInput
                                                max="72"
                                                min="1"
                                                name="postpone_hours"
                                                placeholder="Checkpoint opschorten voor x aantal uur"
                                                type="number">
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <button (click)="save(formCreateComment())" class="btn btn-primary w-100" type="submit">Opslaan</button>
                                </div>
                            </div>
                        </div>
                    }

                    @for (checkpointComment of checkpointComments(); track checkpointComment.id) {
                        <div class="comment-container py-2">
                            <div class="d-flex justify-content-between">
                                <div class="d-flex gap-2 align-items-center">
                                    <b>{{checkpointComment?.user?.name}}</b>
                                    @if (checkpointComment.postpone_hours) {
                                        <small>Opgeschort: {{checkpointComment.postpone_hours}} uur</small>
                                    }
                                </div>
                                <div>
                                    @if (+LocalStorage.getUser()?.id === +checkpointComment.user_id) {
                                        <button (click)="deleteComment($event, checkpointComment)" class="comment-icon" mat-icon-button>
                                            <mat-icon fontIcon="fa-trash" fontSet="fas"></mat-icon>
                                        </button>
                                    }
                                    <span>{{checkpointComment.created_at | codaltDate:'EEE d MMM yyyy HH:mm'}}</span>
                                </div>
                            </div>
                            <pre class="comment-content">{{checkpointComment.comment}}</pre>
                        </div>
                    }
                </div>
            </div>
        }
    </div>
</div>
